const styles = () => {
  return {
    root: { minWidth: '600px' },
    dialogContent: { padding: '20px' },
    rowContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid #e0e0e0',
      padding: '4px 0'
    },
    innerRowContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginLeft: '10px',
      borderBottom: '1px solid #e0e0e0',
      padding: '4px 0'
    },
    value: {
      width: '250px',
      textAlign: 'right',
      fontWeight: 600
    },
    arrayValue: {
      width: '100%',
      textAlign: 'right',
      fontWeight: 600
    },
    viewButtonsContainer: {
      display: 'flex',
      gap: 8,
      marginBottom: 8
    },
    viewButton: {
      padding: '2px 10px',
      cursor: 'pointer',
      border: '1px solid #ccc',
      borderRadius: 4,
      fontSize: 12
    },
    accordionSection: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: 4,
      userSelect: 'none',
      padding: '2px 0',
      fontWeight: 500
    },
    specContainer: {
      display: 'flex',
      gap: 4,
      marginBottom: 8,
      borderBottom: '1px solid #ccc'
    },
    specButton: {
      padding: '4px 12px',
      cursor: 'pointer',
      background: 'none',
      border: 'none'
    }
  };
};

export default styles;
